import { Card, CardContent } from '@/shared/components/ui/card';
import { Stack } from '@/shared/components/ui/row';
import type { RdsSpacing } from '@/shared/styles/rds-spacing';
import { cn } from '@/shared/lib/utils';
import React from 'react';

interface FilterCardProps {
  children: React.ReactNode;
  className?: string;
  /** 필터 행 사이 세로 간격 (RDS Spacing). 기본 16 — 레거시 CardContent space-y-4 */
  gap?: RdsSpacing;
}

/**
 * 검색·필터 폼 래퍼.
 * FilterRow + 부가 필터가 여러 행일 때 행간을 Stack으로 유지한다.
 */
export const FilterCard: React.FC<FilterCardProps> = ({
  children,
  className,
  gap = 16,
}) => (
  <Card
    className={cn('ruda-filter-card border-l-4 border-l-primary/50', className)}
  >
    <CardContent className="p-4">
      <Stack gap={gap}>{children}</Stack>
    </CardContent>
  </Card>
);
